import React from "react";
import challengeTitle from "../../../assets/images/guide/10431/challenge_title.png";
import challengeCards from "../../../assets/images/guide/10431/challenge_cards.png";
import challengeQr from "../../../assets/images/guide/10431/challenge_qr_clean.svg";
import challengeCharacter from "../../../assets/images/guide/10431/challenge_character.png";
import challengeButton from "../../../assets/images/guide/10431/challenge_btn.png";
import airButton from "../../../assets/images/guide/10431/air_button.png";

const Air10431 = () => {
  return (
    <div className="air2509_bg bg_challenge">
      <div className="area air10431_area">
        <section className="air10431_stage" aria-label="AIR 퀴즈 챌린지 안내">
          <div className="air10431_content">
            <div className="air10431_layer air10431_title">
              <img src={challengeTitle} alt="과학동아AiR 퀴즈 챌린지" />
            </div>
            <div className="air10431_layer air10431_cards">
              <img src={challengeCards} alt="퀴즈 미션과 보상 안내" />
            </div>
            <div className="air10431_layer air10431_qr">
              <img src={challengeQr} alt="앱 설치 QR 안내" />
            </div>
            <div className="air10431_layer air10431_buttons" aria-label="퀴즈 챌린지 버튼">
              <a
                href="https://smore.im/form/5dzNgB6J41"
                target="_blank"
                rel="noopener noreferrer"
                className="air10431_button air10431_button_challenge"
              >
                <img
                  className="air10431_button_image air10431_button_image_challenge"
                  src={challengeButton}
                  alt="챌린지 자세히보기"
                />
              </a>
              <a
                className="air10431_button air10431_button_air"
                href="https://air.dongascience.com"
                target="_blank"
                rel="noopener noreferrer"
              >
                <img
                  className="air10431_button_image air10431_button_image_air"
                  src={airButton}
                  alt="과학동아AiR 바로가기"
                />
              </a>
            </div>
            <div className="air10431_layer air10431_character">
              <img src={challengeCharacter} alt="" aria-hidden="true" />
            </div>
          </div>
        </section>
      </div>
    </div>
  );
};

export default Air10431;
